import { TiptapVuetifyPlugin } from 'tiptap-vuetify'

import 'tiptap-vuetify/dist/main.css'

export default function configureTipTap (vueInst, vuetifyInst) {
  vueInst.use(TiptapVuetifyPlugin, {
    vuetify: vuetifyInst,
    iconsGroup: 'mdi'
  })
}
